/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Footer_LabelInputs */

const en_nav_footer_label = /** @type {(inputs: Nav_Footer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footer navigation`)
};

const lv_nav_footer_label = /** @type {(inputs: Nav_Footer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kājenes navigācija`)
};

/**
* | output |
* | --- |
* | "Footer navigation" |
*
* @param {Nav_Footer_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_footer_label = /** @type {((inputs?: Nav_Footer_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Footer_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_footer_label(inputs)
	return en_nav_footer_label(inputs)
});